import { render, staticRenderFns } from "./BuyingTable.vue?vue&type=template&id=65099a8c&scoped=true"
import script from "./BuyingTable.vue?vue&type=script&lang=ts"
export * from "./BuyingTable.vue?vue&type=script&lang=ts"
import style0 from "./BuyingTable.vue?vue&type=style&index=0&id=65099a8c&prod&scoped=true&lang=css"
import style1 from "./BuyingTable.vue?vue&type=style&index=1&id=65099a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65099a8c",
  null
  
)

export default component.exports